module.exports = {"440204001":"东河街道","440204002":"车站街道","440204008":"风采街道","440204100":"新韶镇","440204101":"乐园镇","440204102":"十里亭镇","440204103":"犁市镇","440204104":"花坪镇","440204401":"田螺冲","440204402":"曲仁"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440204.json
// module id = 1957
// module chunks = 0